/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import CloseButton from '../../Buttons/CloseButton';

const CreateModal = ({ handleCreate, isCreating }) => {
  const [name, setName] = useState('');

  useEffect(() => {
    $('#createKeyModal').on('hide.bs.modal', () => {
      setName('');
    });
  }, []);

  return (
    <div
      className='modal'
      id='createKeyModal'
      role='dialog'
      aria-hidden='true'
      data-backdrop='static'
      data-keyboard='false'
    >
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2 className='modal-title'>Create API key</h2>
            <CloseButton
              title='Dismiss Modal'
              handleClose={() => $('#createKeyModal').modal('hide')}
            />
          </div>
          <div className='modal-body'>
            <label htmlFor='Name' className='mb-1'>
              Key name
            </label>
            <div className='form-group mb-1'>
              <input
                className='form-control'
                placeholder='e.g. Production server, Data pipeline'
                id='Name'
                value={name}
                onChange={(e) => setName(e.target.value)}
                maxLength={35}
                required
              />
            </div>
            <small className='text-muted'>
              A label to help you recognise this key later. The key and secret
              are generated for you.
            </small>
          </div>
          <div className='modal-footer'>
            <button
              className='wf-button'
              disabled={!name || isCreating}
              onClick={() => handleCreate(name)}
            >
              {isCreating ? 'Creating…' : 'Create key'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateModal;
